import React, {useState} from 'react';
import moment from 'moment';
import isString from 'lodash/isString';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import CustomInput from './CustomInput';
import CustomInputLabel from './CustomInputLabel';
import DateField from './DateField';
import TimeField from './TimeField';

const DateTimeField = props => {
  const [dt, setDt] = useState(
    props?.defaultValue 
    ? moment(props.defaultValue) 
    : null
  );
  return (
    <Stack paddingTop={0.1}>
      <CustomInput>
        <CustomInputLabel required={props.required || false}>
          {props.label}
        </CustomInputLabel>
        <Stack direction='row'>
          <Box
            style={{maxWidth: '110px', marginTop: '1px'}}
          >
            <DateField
              {...props}
              minDate={props?.minDate || moment().startOf('day')}
              label={null}
              defaultValue={
                isString(props.defaultValue)
                ? moment(props.defaultValue).startOf('day')
                : null
              }
              onChange={(e, str) => { 
                const momentDate = moment(str, 'MM/DD/yyyy');
                const _dt = dt ? dt.clone() : moment().startOf('day').hour(9);
                const newDateTime = _dt
                  .year(momentDate.year())
                  .month(momentDate.month())
                  .date(momentDate.date());
                setDt(newDateTime);
                props.onChange({
                  ...e, 
                  target: {...e.target, value: newDateTime.toISOString()}
                }, newDateTime.toISOString()
                );
              }}
            />
          </Box>
          <Box
            style={{maxWidth: '120px', paddingLeft: '1em'}}
          >
            <TimeField 
              {...props}
              label={null}
              maxWidth='50px'
              defaultValue={
                isString(props.defaultValue)
                ? moment(props.defaultValue, 'hh:mm a')
                : null
              }
              disabled={!dt}
              onChange={(e, str) => {
                console.log('str', str);
                const momentTime = moment(str, 'hh:mm a');
                const newDateTime = dt.clone()
                  .hour(momentTime.hour())
                  .minute(momentTime.minute());
                setDt(newDateTime);
                console.log('time.onChange', dt, newDateTime, newDateTime.toISOString())
                props.onChange({
                  ...e, 
                  target: {...e.target, value: newDateTime.toDate()}
                },
                newDateTime.toDate()
              );
              }}
            />
          </Box>
        </Stack>
      </CustomInput>
    </Stack>
  );
};

export default DateTimeField;